// extracted by mini-css-extract-plugin
export var shareButton = "share-button-module--shareButton--DOFew";
export var facebook = "share-button-module--facebook--kY11W";
export var x = "share-button-module--x--PJ3O+";
export var line = "share-button-module--line--n+r+q";
export var note = "share-button-module--note--EL2EB";
export var shareLink = "share-button-module--shareLink--2QhyE";